
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NavigationLGEComponent } from './components/navigation-lge/navigation-lge.component';
import { NavigationComponent } from './components/navigation/navigation.component';
import { TestLiveComponent } from './components/test-live/test-live.component';

const routes: Routes = [
    { path: 'testme888', component: TestLiveComponent },
    { path: 'lgeresults', component: NavigationLGEComponent },
    { path: '', component: NavigationComponent }
];


@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }